import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import profileIcon from "../../icons/profileIcon.png";
import {
  setBlurOff,
  setNavOff,
} from "../../store/slices/hostSlices";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../store/slices/hostSlices";
import { useNavigate } from "react-router-dom";
import {
  getHostEarnings,
  getHostProfile,
  getHostProfileImage,
  updateHostProfile,
} from "../../store/thunks/hostActions";
import { Alert, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import request from "../../utils/request";
import CsvExport from "./CsvExport";
import BulkUploadModal from "../BulkUploadModal";

function HostNav({ searchBar, setSearch, hide, edit }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [error, setError] = useState();
  const [uploading, setUploading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [frontURL, setFrontURL] = useState();
  const [frontURLPreview, setFrontUrlPreview] = useState();
  const fileInputFront = useRef(null);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

  const { hostInfo } = useSelector((state) => state.host);

  const { Info, loading: loadingDetails, loadingImage } = useSelector(
    (state) => state.hostDetails
  );
  const { loading, earnings } = useSelector((state) => state.hostEarnings);
  const { property } = useSelector((state) => state.propertyDetails);

  let total = 0;
  for (const earning in earnings) {
    const sum = earnings[earning].earnings.reduce(
      (acc, amount) => acc + amount,
      0
    );
    total += sum;
  }

  let firstName, lastName, isManager, isOnBoarded;
  if (Info) {
    firstName = Info.firstName;
    lastName = Info.lastName;
    isManager = Info.isManager;
    isOnBoarded = Info.isOnBoarded;
  }

  const { hostBlur } = useSelector((state) => state);

  const handleOnDragOver = (event) => {
    event.preventDefault();
  };
  const handleFile = async (e) => {
    setUploading(true);
    const file = e.target.files[0];
    if(!file) return;
    setFrontURL(file);

    const formData = new FormData();
    formData.append("profilePicture", file);
    try {
      const { data } = await request.patch(`/hosts/${Info?._id}`, formData, {
        header: {
          "Content-type": "multipart/form-data",
        },
      });

      setSuccess(true);
      setUploading(false);
      await dispatch(getHostProfile(hostInfo._id));
      dispatch(getHostProfileImage());
    } catch (error) {
      setUploading(false);
      setSuccess(false);
      console.log(error.response.data.error);
      setError(error.response.data.error);
    }
  };
  const handleOnDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    handleFile(event);
  };

  useEffect(() => {
    if (!Info && hostInfo?._id) {
      dispatch(getHostProfile(hostInfo._id));
      dispatch(getHostEarnings(hostInfo._id));
    }
  }, [Info, hostInfo?._id, dispatch]);

  useEffect(() => {
    setTimeout(() => {
      error && setError(null);
      success && setSuccess(null);
    }, 2000);
  }, [error, success]);

  return (
    <>
      {hostBlur && (
        <div
          onClick={() => {
            dispatch(setBlurOff());
            dispatch(setNavOff());
          }}
          className={`absolute opacity-40 top-0 left-0 h-screen w-full bg-black z-10 min-h-[650px]`}
        ></div>
      )}

      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14">
            
            {/* Profile Section */}
            <div className="flex items-center space-x-3">
              <div className="flex items-center space-x-2.5">
                <div
                  className={`drop_zone ${!edit && " pointer-events-none"}`}
                  onDragOver={handleOnDragOver}
                  onDrop={handleOnDrop}
                  onClick={() => fileInputFront.current.click()}
                >
                  <button className="relative">
                    {uploading || loadingImage ? (
                      <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                        <CircularProgress size={20} />
                      </div>
                    ) : frontURLPreview ? (
                      <img
                        src={frontURLPreview}
                        alt="host-image"
                        className="w-10 h-10 rounded-full object-cover border-2 border-gray-200 hover:border-gray-400 transition-colors cursor-pointer"
                      />
                    ) : (
                      <img
                        src={Info?.profilePicture}
                        alt="image-placeholder"
                        className="w-10 h-10 rounded-full object-cover border-2 border-gray-200 hover:border-gray-400 transition-colors cursor-pointer"
                      />
                    )}
                  </button>
                  <input
                    id="frontInput"
                    className="bg-black"
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    ref={fileInputFront}
                    hidden
                    onChange={(e) => handleFile(e)}
                  />
                </div>
                
                <div className="flex flex-col">
                  <h5 className="font-bold text-gray-900 text-xs">
                    {firstName} {lastName}
                  </h5>
                  {isManager && (
                    <p className="text-[10px] text-gray-500 font-medium">Property Manager</p>
                  )}
                </div>
              </div>

            </div>

            {/* Search and Actions */}
            <div className="flex items-center space-x-3">
              {searchBar && (
                <div className="relative hidden md:block">
                  <input
                    type="text"
                    placeholder="Search properties..."
                    className="w-72 bg-gray-100 border border-gray-200 rounded-lg py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all"
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                </div>
              )}

              {/* Earnings Display */}
              <div className="hidden lg:flex items-center px-3 py-1.5 rounded-lg">
                <span className="text-sm font-bold text-green-600">${total?.toFixed(2)}</span>
              </div>

              {/* Action Buttons */}
              <div className="hidden lg:flex items-center space-x-2">
                <NavLink
                  to="/add-property"
                  className={`${
                    !isOnBoarded && "pointer-events-none opacity-50"
                  } ${hide === true && "hidden"}`}
                >
                  <button className="bg-gray-900 text-white font-bold px-3.5 py-2 rounded-xl transition-all duration-200 hover:bg-gray-800 text-xs">
                    + Add Property
                  </button>
                </NavLink>
                
                <CsvExport />
                
                <button
                  onClick={() => setShowBulkUploadModal(true)}
                  className="bg-white text-gray-600 border border-gray-200 font-semibold px-3.5 py-2 rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-xs"
                >
                  Bulk Upload
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Search */}
          {searchBar && (
            <div className="md:hidden pb-3">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search properties..."
                  className="w-full bg-gray-100 border border-gray-200 rounded-lg py-2 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 transition-all"
                  onChange={(e) => setSearch(e.target.value)}
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Alerts */}
      {error && (
        <Alert
          severity="error"
          sx={{
            position: "fixed",
            width: "90%",
            margin: "auto",
            top: 20,
            left: 0,
            right: 0,
            zIndex: 10,
          }}
        >
          {error}
        </Alert>
      )}
      {success && (
        <Alert
          severity="success"
          sx={{
            position: "fixed",
            width: "90%",
            margin: "auto",
            top: 20,
            left: 0,
            right: 0,
            zIndex: 10,
          }}
        >
          Profile Picture Updated
        </Alert>
      )}

      {showBulkUploadModal && (
        <BulkUploadModal onClose={() => setShowBulkUploadModal(false)} />
      )}
    </>
  );
}

export default HostNav;
